import { Noise } from './Noise'
import { Slider } from './Slider'

export const Component = { Noise, Slider }
